<template>
  <v-navigation-drawer v-model="drawerComputed" app clipped>
    <v-list dense>
      <v-list-item @click="mainMenuOnClick('/')">
        <v-list-item-action>
          <v-icon>dashboard</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        @click="mainMenuOnClick('/projects')"
        v-if="$store.getters['UserStore/userLoggedIn'] !== null"
      >
        <v-list-item-action>
          <v-icon>folder</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Projects</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        @click="mainMenuOnClick('/apps')"
        v-if="
          $store.getters['UserStore/userLoggedIn'] !== null &&
            $store.getters['UserStore/userRole'] === 'super_admin'
        "
      >
        <v-list-item-action>
          <v-icon>mdi-dots-horizontal-circle</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Apps</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        @click="mainMenuOnClick('/pois')"
        v-if="
          $store.getters['UserStore/userLoggedIn'] !== null &&
            $store.getters['UserStore/userRole'] === 'super_admin'
        "
      >
        <v-list-item-action>
          <v-icon>mdi-dots-horizontal-circle</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>POIs</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- <v-list-item
        @click="mainMenuOnClick('/project-media')"
        v-if="$store.getters['UserStore/userLoggedIn'] !== null"
      >
        <v-list-item-action>
          <v-icon>mdi-dots-horizontal-circle</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Media</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
      <!-- <v-list-item
					@click="mainMenuOnClick('/polygons-editor')"
					v-if="$store.getters['UserStore/userLoggedIn'] !== null"
				>
					<v-list-item-action>
						<v-icon>mdi-dots-horizontal-circle</v-icon>
					</v-list-item-action>
					<v-list-item-content>
						<v-list-item-title>Polygons Editor</v-list-item-title>
					</v-list-item-content>
        </v-list-item>-->
      <v-list-item
        @click="mainMenuOnClick('/user-profile')"
        v-if="$store.getters['UserStore/userLoggedIn'] !== null"
      >
        <v-list-item-action>
          <v-icon>account_box</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Profile</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!--      <v-list-item v-if="$store.getters['UserStore/userLoggedIn'] !== null">-->
      <!--        <v-list-item-action>-->
      <!--          <v-icon>settings</v-icon>-->
      <!--        </v-list-item-action>-->
      <!--        <v-list-item-content>-->
      <!--          <v-list-item-title>Settings</v-list-item-title>-->
      <!--        </v-list-item-content>-->
      <!--      </v-list-item>-->

      <v-list-item
        @click="mainMenuOnClick('/login')"
        v-if="$store.getters['UserStore/userLoggedIn'] === null"
      >
        <v-list-item-action>
          <v-icon>mdi-lock-open</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Login</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        @click="mainMenuOnClick('/logout')"
        v-if="$store.getters['UserStore/userLoggedIn'] !== null"
      >
        <v-list-item-action>
          <v-icon>mdi-lock</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  components: {},

  props: {
    source: String,
    drawer: Boolean
  },

  data: () => ({
    drawerLocal: null
  }),

  created() {
    this.$vuetify.theme.dark = true
    //console.log(this.$store.getters.userLoggedIn);
  },

  methods: {
    mainMenuOnClick: function(menuItemId) {
      if (menuItemId === '/pois') {
        this.$store.dispatch('PoiStore/setPoiContext', 'app')
      }
      this.$router.push(menuItemId).catch(err => {})
    }
  },
  watch: {
    drawer: function(newValue) {
      this.drawerLocal = newValue
    }
  },
  computed: {
    drawerComputed: {
      get: function() {
        return this.drawerLocal
      },
      set: function(newValue) {
        this.drawerLocal = newValue
        this.$emit('drawerChange', this.drawerLocal)
      }
    }
  }
}
</script>
